<template>
  <div>
    <nav-header></nav-header>
    <div class="signup-form validate-form p-l-50 p-r-50 p-t-10">
      <section>
        <div class="page-title">
          <h2>Cadastrar Usuário</h2>
        </div>
        <hr />
        <div class="wrap-form-fields" style="align: center">
          <div class="input-container">
            <label class="label-input">Nome:</label>
            <input
              v-model="name"
              type="name"
              id="inputName"
              class="input-field"
              autocomplete="off"
            />
          </div>
          <br />
          <div class="input-container">
            <i class="fa fa-envelope icon"></i>
            <label class="label-input">Email:</label>
            <input
              v-model="email"
              type="email"
              id="inputEmail"
              class="input-field"
              autocomplete="off"
            />
          </div>
          <br />
          <div class="input-container">
            <i class="fa fa-envelope icon"></i>
            <label>Confirme o email:</label>
            <input
              v-model="reEmail"
              type="email"
              id="reInputEmail"
              class="input-field"
              autocomplete="off"
              @paste.prevent
            />
          </div>
          <br />
          <div class="input-container">
            <i class="fa fa-key icon"></i>
            <label>Senha:</label>
            <input
              type="password"
              v-model="password"
              id="inputPassword"
              class="input-field"
            />
          </div>
          <password
            v-model="password"
            :strength-meter-only="true"
            @score="setPasswordScore"
          />
          <label>Permissão:</label>
          <b-form-select
            v-model="selectedRole"
            :options="optionsRole"
            v-if="role == 'ADMIN_CEPE'"
            style="font-size: 20px"
          ></b-form-select>
          <b-form-select
            v-model="selectedRole"
            :options="optionsRoleCompany"
            v-if="role == 'ADMIN_EMPRESA'"
            style="font-size: 20px"
          ></b-form-select>
          <br /><br />
          <div v-if="selectedRole !== 'ADMIN_CEPE' && role == 'ADMIN_CEPE'">
            <label>Empresa:</label>
            <b-form-select
              v-model="selectedCompany"
              :options="optionsCompany"
              style="font-size: 20px"
            />
          </div>
          <br /><br />
        </div>
        <button
          class="btn btn-secondary"
          v-on:click="$router.push({ name: 'home' })"
          style="aling: left; margin-left: 10px;"
        >
          Cancelar
        </button>
        <button
          class="btn btn-primary"
          v-on:click="this.signup"
          style="aling: left"
        >
          Cadastrar
        </button>
      </section>
    </div>
    <user-profile-footer></user-profile-footer>
  </div>
</template>

<style scoped src="@/assets/css/util.css">
</style>

<style scoped>

  .footer {
    z-index: 1;
  }

  .signup-form {
    margin-bottom: 120px;
  }

  label {
    font-size: 18px;
    display: inline-block
  }
</style>

<script>
import axios from "axios";
import Password from "vue-password-strength-meter";
import config from "../helpers/generalConfig";
import NavHeader from "../components/NavHeader.vue";
import UserProfileFooter from "../components/UserProfileFooter.vue";

export default {
  components: { Password, NavHeader, UserProfileFooter },
  data() {
    return {
      listaUsuarios: [],
      form: { usuario: null },
      disabled: false,
      role: null,
      selectedRole: null,
      name: "",
      email: "",
      reEmail: "",
      password: "",
      passwordScore: 0,
      optionsRole: [
        { value: null, text: "Selecione a permissão..." },
        { value: "DESENVOLVEDOR", text: "Desenvolvedor" },
        { value: "ADMIN_EMPRESA", text: "Administrador" },
        { value: "ADMIN_CEPE", text: "Administrador CEPE" },
      ],
      optionsRoleCompany: [
        { value: null, text: "Selecione a permissão..." },
        { value: "DESENVOLVEDOR", text: "Desenvolvedor" },
        { value: "ADMIN_EMPRESA", text: "Administrador" },
      ],
      selectedCompany: null,
      optionsCompany: [
        { value: null, text: "Selecione a empresa..." },
      ],
    };
  },
  created() {
    this.setRole();
    this.getCompanies();
  },
  methods: {
    signup() {
      if (!this.email) {
        this.$bvToast.toast("Informe um email válido.", {
          title: "Email inválido",
          variant: "danger",
          solid: true,
        });
        return;
      }
      if (this.reEmail !== this.email) {
        this.$bvToast.toast("Os emails devem ser iguais.", {
          title: "Email de confirmação inválido",
          variant: "danger",
          solid: true,
        });
        return;
      }
      if (!this.name) {
        this.$bvToast.toast("Informe um nome válido.", {
          title: "Nome inválido",
          variant: "danger",
          solid: true,
        });
        return;
      }
      if (!this.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{4,}$/gi)) {
        this.$bvToast.toast(
          "A senha deve conter pelo menos 1 dígito numérico, 1 letra minúscula, 1 letra maiúscula e 1 caráter especial.", 
          { title: "Senha inválida", variant: "danger", solid: true }
        );
        return;
      }
      if (this.role === 'ADMIN_CEPE' && !this.selectedCompany && !this.optionsRole == 'ADMIN_CEPE') {
        this.$bvToast.toast(
          "Selecione uma empresa válida", 
          { title: "Empresa não selecionada", variant: "danger", solid: true }
        );
        return;
      }
      axios
        .post(`${config.jsonServer}/user/signup`, {
          nome_usuario: this.name,
          email_usuario: this.email,
          senha_usuario: this.password,
          permissao: this.selectedRole,
          id_empresa: this.selectedRole === 'ADMIN_CEPE' || this.role === 'ADMIN_EMPRESA' ?
            this.$store.getters["auth/user"].CompanyId : this.selectedCompany
        })
        .then((response) => {
          const user = response.data;
          if (user) {
            this.name = '';
            this.email = '';
            this.reEmail = '';
            this.password = '';
            this.selectedRole = null;
            this.$root.$bvToast.toast("Cadastro realizado com sucesso.", {
              title: "Cadastro realizado",
              variant: "success",
              solid: true,
            });
          }
          this.$router.push('/home');
        })
        .catch((err) => {
          if (err.response) {
            this.$bvToast.toast(err.response.data.message, {
              title: "Erro ao cadastrar",
              variant: "danger",
              solid: true,
            });
          }
        });
    },
    setPasswordScore(score) {
      this.passwordScore = score;
    },
    headers() {
      const token = this.$store.getters["auth/token"].token;
      return { headers: { Authorization: "Bearer " + token } };
    },
    getCompanies() {
      axios.get(`${config.jsonServer}/company`, this.headers())
        .then((companies) => {
          this.optionsCompany = this.optionsCompany
            .concat(companies.data.map((c) => {
                return {
                  value: c.id_empresa,
                  text: c.nome_empresa
                }
              }
            ));
        })
        .catch((err) => {
          if (err.response) {
            this.$bvToast.toast(err.response.data.message, {
              title: "Erro ao carregar projeto",
              variant: "danger",
              solid: true,
            });
          } else {
            this.$bvToast.toast('Sem resposta do servidor', {
              title: "Erro ao carregar empresas",
              variant: "danger",
              solid: true,
            });
          }
        })
    },
    setRole() {
      this.role = this.$store.getters["auth/user"].Role;
    },
    validateCompany(select) {
      console.log(select);
      this.selectedCompany = select;
    }
  },
};
</script>